
import { Component, Vue, Ref } from 'vue-property-decorator'
import { HelpService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import TableList from '../../components/help/article_table.vue'
@Component({
    components: {
        ScrollTo,
        TableList
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private list: any[] = []
    private typeList: any[] = []
    private isLoading = true
    private firstInit = true
    private typeId = -1

    async mounted() {
        this.typeId = +this.$route.query.id
        await this.getList()
        await this.getTypeList()
        if (this.firstInit) {
            this.isLoading = false
        }
        this.firstInit = false
    }

    async getTypeList() {
        const result = await HelpService.getArticleTypes({})
        if (result.status === 200) {
            this.pageTotal = result.data.length
            this.typeList = result.data
        }
    }

    async getList() {
        this.isLoading = true
        const params = {
            type_id: this.typeId ? this.typeId : undefined,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await HelpService.getArticles(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.list = result.data.list
        }
        if (!this.firstInit) {
            this.isLoading = false
        }
    }

    // 分页
    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getList)
    }

    // 删除
    private onDelete(article: any) {
        this.$confirm('你正在删除文章, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteArticle(article)
        })
    }

    async deleteArticle(article: any) {
        const params = { id: article.id }
        const result = await HelpService.deleteArticle(params)
        if (result.status === 200) {
            this.list.splice(this.list.indexOf(article), 1)
            --this.pageTotal
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    onChange() {
        this.getList()
    }
}
